var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "5", md: "3" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "search",
                      label: _vm.$t("global.search"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "3" } },
                [
                  _c("v-select", {
                    attrs: {
                      multiple: "",
                      "append-icon": "fa-columns",
                      label: _vm.$t("global.columns"),
                      "single-line": "",
                      "hide-details": "",
                      "small-chips": "",
                      items: _vm.availableColumns,
                      "item-text": "text",
                      "item-value": "selectValue"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "selection",
                        fn: function(ref) {
                          var item = ref.item
                          var index = ref.index
                          return [
                            index < 2
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "primary",
                                      "text-color": "white",
                                      small: ""
                                    }
                                  },
                                  [_c("span", [_vm._v(_vm._s(item.text))])]
                                )
                              : _vm._e(),
                            index === 2
                              ? _c(
                                  "span",
                                  { staticClass: "grey--text caption" },
                                  [
                                    _vm._v(
                                      "(+" +
                                        _vm._s(_vm.selectedColumns.length - 2) +
                                        " " +
                                        _vm._s(_vm.$t("global.others")) +
                                        ")"
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          "custom-filter": _vm.filterOverAllProperty,
          headers: _vm.headers,
          items: _vm.bookings,
          "sort-by": _vm.pagination.sortBy,
          "sort-desc": _vm.pagination.descending,
          search: _vm.search,
          loading: _vm.$store.getters["Ajax/loading"] ? "accent" : false,
          "items-per-page": 5
        },
        on: {
          "update:sortBy": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sort-by": function($event) {
            return _vm.$set(_vm.pagination, "sortBy", $event)
          },
          "update:sortDesc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          },
          "update:sort-desc": function($event) {
            return _vm.$set(_vm.pagination, "descending", $event)
          }
        },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function(props) {
                return [
                  _c(
                    "tr",
                    [
                      _vm._l(_vm.selectedColumns, function(column) {
                        return _c(
                          "td",
                          { key: column },
                          [
                            column === "creation_date"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formatDateView(
                                          props.item.creation_date
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              : _vm._e(),
                            column === "reservation_number"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(props.item.reservation_number) +
                                      " "
                                  ),
                                  props.item.is_cancelled === 1
                                    ? _c(
                                        "v-chip",
                                        {
                                          staticStyle: {
                                            color: "#FFE3F3",
                                            "background-color":
                                              "#ff99d0 !important"
                                          },
                                          attrs: {
                                            label: "",
                                            outlined: "",
                                            small: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("booking.canceled")) +
                                              " "
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("assigned-delegations-chip", {
                                    attrs: {
                                      delegations: props.item.delegations
                                    }
                                  })
                                ]
                              : _vm._e(),
                            column === "route"
                              ? [
                                  props.item.flightAttributes
                                    .start_airport_code == null
                                    ? _c("div", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              props.item.flightAttributes
                                                .itinerary
                                            ) +
                                            " "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flight-date grey--text"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "booking.flight.missingDetailedInformation"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    : _c(
                                        "div",
                                        [
                                          _c(
                                            "v-row",
                                            [
                                              _c(
                                                "v-col",
                                                { staticClass: "flight-part" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flight-direction grey--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "booking.flight.departure"
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flight-airport"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass: "bigger",
                                                          staticStyle: {
                                                            "font-weight":
                                                              "bold"
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: "",
                                                                color: "white"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var on =
                                                                        ref.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "accent--text"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                props
                                                                                  .item
                                                                                  .flightAttributes
                                                                                  .start_airport_code
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#0f0f0f"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      props.item
                                                                        .flightAttributes
                                                                        .start_airport_name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "arrow"
                                                            },
                                                            [_vm._v("➞")]
                                                          ),
                                                          _c(
                                                            "v-tooltip",
                                                            {
                                                              attrs: {
                                                                bottom: "",
                                                                color: "white"
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "activator",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var on =
                                                                        ref.on
                                                                      return [
                                                                        _c(
                                                                          "span",
                                                                          _vm._g(
                                                                            {
                                                                              staticClass:
                                                                                "accent--text"
                                                                            },
                                                                            on
                                                                          ),
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                props
                                                                                  .item
                                                                                  .flightAttributes
                                                                                  .end_airport_code
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#0f0f0f"
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      props.item
                                                                        .flightAttributes
                                                                        .end_airport_name
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            props.item
                                                              .flightAttributes
                                                              .start_time !=
                                                              null
                                                              ? props.item.flightAttributes.start_time.substr(
                                                                  0,
                                                                  5
                                                                )
                                                              : _vm.$t(
                                                                  "global.noData"
                                                                )
                                                          ) +
                                                          " - " +
                                                          _vm._s(
                                                            props.item
                                                              .flightAttributes
                                                              .end_time != null
                                                              ? props.item.flightAttributes.end_time.substr(
                                                                  0,
                                                                  5
                                                                )
                                                              : _vm.$t(
                                                                  "global.noData"
                                                                )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flight-date grey--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            props.item
                                                              .flightAttributes
                                                              .start_date !=
                                                              null
                                                              ? _vm.dayOfWeek(
                                                                  props.item.flightAttributes.start_date.substr(
                                                                    0,
                                                                    10
                                                                  )
                                                                )
                                                              : _vm.$t(
                                                                  "global.noData"
                                                                )
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            props.item
                                                              .flightAttributes
                                                              .start_date !=
                                                              null
                                                              ? _vm.formatDateView(
                                                                  props.item
                                                                    .flightAttributes
                                                                    .start_date
                                                                )
                                                              : _vm.$t(
                                                                  "global.noData"
                                                                )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              props.item.flightAttributes
                                                .return_start_airport_code !=
                                              null
                                                ? _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "flight-part"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flight-direction grey--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "booking.flight.arrival"
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flight-airport"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "bigger",
                                                              staticStyle: {
                                                                "font-weight":
                                                                  "bold"
                                                              }
                                                            },
                                                            [
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                    color:
                                                                      "white"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "accent--text"
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    props
                                                                                      .item
                                                                                      .flightAttributes
                                                                                      .return_start_airport_code
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        color:
                                                                          "#0f0f0f"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .flightAttributes
                                                                            .return_start_airport_name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "arrow"
                                                                },
                                                                [_vm._v("➞")]
                                                              ),
                                                              _c(
                                                                "v-tooltip",
                                                                {
                                                                  attrs: {
                                                                    bottom: "",
                                                                    color:
                                                                      "white"
                                                                  },
                                                                  scopedSlots: _vm._u(
                                                                    [
                                                                      {
                                                                        key:
                                                                          "activator",
                                                                        fn: function(
                                                                          ref
                                                                        ) {
                                                                          var on =
                                                                            ref.on
                                                                          return [
                                                                            _c(
                                                                              "span",
                                                                              _vm._g(
                                                                                {
                                                                                  staticClass:
                                                                                    "accent--text"
                                                                                },
                                                                                on
                                                                              ),
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    props
                                                                                      .item
                                                                                      .flightAttributes
                                                                                      .return_end_airport_code
                                                                                  )
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        }
                                                                      }
                                                                    ],
                                                                    null,
                                                                    true
                                                                  )
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticStyle: {
                                                                        color:
                                                                          "#0f0f0f"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          props
                                                                            .item
                                                                            .flightAttributes
                                                                            .return_end_airport_name
                                                                        )
                                                                      )
                                                                    ]
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                props.item.flightAttributes.return_start_time.substr(
                                                                  0,
                                                                  5
                                                                )
                                                              ) +
                                                              " - " +
                                                              _vm._s(
                                                                props.item.flightAttributes.return_end_time.substr(
                                                                  0,
                                                                  5
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "flight-date grey--text"
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.dayOfWeek(
                                                                  props.item.flightAttributes.return_start_date.substr(
                                                                    0,
                                                                    10
                                                                  )
                                                                )
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.formatDateView(
                                                                  props.item
                                                                    .flightAttributes
                                                                    .return_start_date
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                ]
                              : _vm._e(),
                            column === "organization_unit"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(props.item.organization_unit) +
                                      " "
                                  )
                                ]
                              : _vm._e(),
                            column === "ticket_number"
                              ? [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.item.flightAttributes
                                          .ticket_number
                                      ) +
                                      " "
                                  )
                                ]
                              : _vm._e(),
                            column === "passengers"
                              ? _vm._l(props.item.passengers, function(
                                  passenger
                                ) {
                                  return _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "text-transform": "capitalize"
                                      }
                                    },
                                    [
                                      _vm._v(" " + _vm._s(passenger) + " "),
                                      _c("br")
                                    ]
                                  )
                                })
                              : _vm._e(),
                            column === "total_amount"
                              ? [
                                  _c(
                                    "span",
                                    { staticClass: "datatable-total-amount" },
                                    [
                                      props.item.invoice_gross_value !== null
                                        ? [
                                            _vm._v(
                                              _vm._s(
                                                props.item.invoice_gross_value
                                              ) +
                                                " " +
                                                _vm._s(
                                                  props.item.invoice_currency
                                                )
                                            )
                                          ]
                                        : props.item.total_amount !== null
                                        ? [
                                            _vm._v(
                                              _vm._s(props.item.total_amount) +
                                                " PLN"
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      _c(
                        "td",
                        { staticClass: "text-center text-no-wrap" },
                        [
                          _vm._t(
                            "action-column",
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    to:
                                                      "/booking/flight/detail/" +
                                                      props.item.id,
                                                    icon: ""
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("remove_red_eye")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("global.goToDetails")) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  staticClass: "mx-0",
                                                  attrs: {
                                                    disabled:
                                                      _vm.$store.getters[
                                                        "Ajax/loading"
                                                      ],
                                                    icon: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.downloadAttachment(
                                                        props.item.id
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("cloud_download")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("global.downloadFile")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            { booking: props.item }
                          )
                        ],
                        2
                      )
                    ],
                    2
                  )
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }